import { render, staticRenderFns } from "./TagerSetting.vue?vue&type=template&id=866ca526&scoped=true"
import script from "./TagerSetting.vue?vue&type=script&lang=js"
export * from "./TagerSetting.vue?vue&type=script&lang=js"
import style0 from "./TagerSetting.vue?vue&type=style&index=0&id=866ca526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866ca526",
  null
  
)

export default component.exports